import React, { useState } from 'react';
import CancelMonitoringModal from '../../../components/CancelMonitoringModal/CancelMonitoringModal';
import {
  ActionAnchor,
  ActionButton,
  Item,
  Message,
  Title,
  LinkButton,
  OrderedList,
} from './ActionItemsStyles';

const ActionItems = () => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [showFreezeCreditDetails, setShowFreezeCreditDetails] = useState(false);

  return (
    <>
      <div>
        <Item>
          <Title>Freeze Your Credit</Title>
          <Message>
            Prevent credit, loans and services from being approved in your name without your consent
            by contacting each of the nationwide credit bureaus
          </Message>
          <LinkButton onClick={() => setShowFreezeCreditDetails(!showFreezeCreditDetails)}>
            {showFreezeCreditDetails ? 'Less Details' : 'More Details'}
          </LinkButton>
          {showFreezeCreditDetails && (
            <OrderedList>
              <li>
                <span>Experian Security Freeze</span>
                <ActionAnchor href="https://www.experian.com/freeze/center.html">
                  <i className="far fa-external-link" />
                </ActionAnchor>
              </li>
              <li>
                <span>Equifax Security Freeze</span>
                <ActionAnchor href="https://www.equifax.com/personal/credit-report-services/credit-freeze/">
                  <i className="far fa-external-link" />
                </ActionAnchor>
              </li>
              <li>
                <span>TransUnion Security Freeze</span>
                <ActionAnchor href="https://www.transunion.com/credit-freeze">
                  <i className="far fa-external-link" />
                </ActionAnchor>
              </li>
              <li>
                <span>Innovis Security Freeze</span>
                <ActionAnchor href="https://www.innovis.com/personal/securityFreeze">
                  <i className="far fa-external-link" />
                </ActionAnchor>
              </li>
            </OrderedList>
          )}
        </Item>
        <Item>
          <Title>Opt Out Of Pre-Approved Offers</Title>
          <Message>
            Remove your name from prescreened credit or insurance offer mailing lists from Experian,
            Innovis, TransUnion and Equifax
          </Message>
          <ActionAnchor href="https://www.optoutprescreen.com/">
            Get Started
            <i className="far fa-external-link" />
          </ActionAnchor>
        </Item>
        <Item>
          <Title>Add Yourself to &quot;Do Not Call&quot; (DNC) List</Title>
          <Message>
            Register on the federal government’s Do Not Call (DNC) Registry and avoid unsolicited
            telemarketing calls
          </Message>
          <ActionAnchor href="https://www.donotcall.gov/">
            Get Started
            <i className="far fa-external-link" />
          </ActionAnchor>
        </Item>
        <Item>
          <Title>Cancel Monitoring Services</Title>
          <Message>
            Should you no longer need monitoring services, you can unenroll at anytime
          </Message>
          <ActionButton onClick={() => setIsCancelModalOpen(true)}>Cancel Monitoring</ActionButton>
        </Item>
      </div>
      <CancelMonitoringModal
        isOpen={isCancelModalOpen}
        onRequestClose={() => setIsCancelModalOpen(false)}
      />
    </>
  );
};

export default ActionItems;
